module.exports = __webpack_public_path__ + "static/media/p2.358a3f0a.svg";